import * as yup from "yup";
export const ProfileSchema = yup.object({
  title: yup.string().required("Job title is required"),
  about: yup.string().required("About info is required"),
});
